import { useEffect } from 'react'

export default function OdorControl() {
  useEffect(() => {
    document.title = 'Industrial Odor Control Equipment Supplier | Yixing, China'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">INDUSTRIAL ODOR & AIR POLLUTION CONTROL</p>
        <h1>Odor Control Equipment Supply from Yixing, China</h1>
        <p>Biological odor control and activated carbon equipment can be manufactured by Grace's family-owned facility. FRP and PP packages are supplied through selected specialist manufacturing partners according to the confirmed project scope.</p>
      </section>

      <section className="page-content">
        <h2>Design Basis</h2>
        <p>Define the source, target and test basis before selecting equipment. Airflow alone is not enough. The pollutant profile, operating pattern, capture arrangement, materials and acceptance method determine the responsible equipment route.</p>

        <h3>01 Emission source</h3>
        <p>Identify the process, collection points, enclosure condition, exhaust pattern and whether the source is continuous or intermittent.</p>

        <h3>02 Pollutant profile</h3>
        <p>Provide known odor compounds, concentration ranges, t and whether the source is continuous or intermittent.</p>
      </section>
    </div>
  )
}
